import React, { useState } from "react";
import Library from "./Library";
import Videos from "./Videos";
import AppLayout from "../components/AppLayout";

/** Catalog = Library kanban + Video catalog table, in one nav.
 *  Renders BOTH children but hides the inactive one with display:none so
 *  their internal state + AppLayout each work independently. */
export default function Catalog() {
  const [tab, setTab] = useState("videos"); // videos | library

  return (
    <div data-testid="catalog-root">
      <div style={{ display: tab === "videos" ? "block" : "none" }}>
        <Videos extraTabBar={
          <CatalogTabs tab={tab} setTab={setTab} />
        } />
      </div>
      <div style={{ display: tab === "library" ? "block" : "none" }}>
        <Library extraTabBar={
          <CatalogTabs tab={tab} setTab={setTab} />
        } />
      </div>
    </div>
  );
}

function CatalogTabs({ tab, setTab }) {
  return (
    <div className="flex gap-2 mb-6" data-testid="catalog-tabs">
      <TabBtn active={tab === "videos"}  onClick={() => setTab("videos")}  label="Video Catalog"  sub="Per-platform pricing" testid="cat-tab-videos" />
      <TabBtn active={tab === "library"} onClick={() => setTab("library")} label="Library Kanban" sub="Idea → posted"        testid="cat-tab-library" />
    </div>
  );
}

function TabBtn({ active, onClick, label, sub, testid }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className={`flex flex-col items-start px-4 py-3 border transition ${active ? "border-[color:var(--gio-primary)] text-[color:var(--gio-primary)] bg-[color:var(--gio-primary)]/10" : "border-zinc-800 text-zinc-400 hover:text-white"}`}>
      <span className="font-mono-ui uppercase tracking-wider text-[11px]">{label}</span>
      <span className="text-[10px] text-zinc-500">{sub}</span>
    </button>
  );
}
